import React from 'react'
import { Link } from 'react-router-dom'
import { LatestCoursesType } from '../../../models/latest-courses-model'

const CoursesCardArticle = (props: {article: LatestCoursesType[]}) => {
    const article = props.article
    return (
        <div className="col-sm">
            <div className="feed-single">
          <img src={article[0]?.imageUrl} alt={article[0]?.name} loading="lazy" />
                <div className="feed-content">
                    <Link to='/education/courses'><h5>Learning</h5></Link>
                    <ul>
                    {
                            (article.length > 1) ? (
                                article?.map((item, index) => {
                                    return <li key={index}>
                                                <Link to={"/products/" + item.nodeName} dangerouslySetInnerHTML={{__html: item.name}}></Link>
                                            </li>
                                })
                                
                            ): (
                                <li>
                                    <Link to={article[0]?.nodeName} dangerouslySetInnerHTML={{__html: article[0]?.name}}></Link>
                                </li>
                            )
                        }
                    </ul>
                </div>
                <div className="Newsrelink"></div>
            </div>
        </div>
    )
}

export default CoursesCardArticle
